(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tv-drop-waitlist"] && !Shopify.designMode) return;
  try {
    
(function () {
  var rails = document.querySelectorAll('[data-tvdw-rail]');
  rails.forEach(function (rail) {
    var dots = rail.parentElement.querySelectorAll('.tvdw__dot');
    if (!dots.length) return;
    rail.addEventListener('scroll', function () {
      requestAnimationFrame(function () {
        var i = Math.round(rail.scrollLeft / rail.clientWidth);
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      });
    });
  });
  if (window.__tvoVideo) return;
  window.__tvoVideo = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function activate(v) {
    if (!v.dataset.pending) return;
    delete v.dataset.pending;
    var sources = v.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].dataset.src;
      sources[i].removeAttribute('data-src');
    }
    v.muted = true;
    v.load();
  }
  function playSafe(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  var vids = document.querySelectorAll('video[data-tvo-video]');
  if (!vids.length) return;
  for (var i = 0; i < vids.length; i++) vids[i].dataset.pending = '1';
  if (reduce || !('IntersectionObserver' in window)) {
    if (!reduce) for (var j = 0; j < vids.length; j++) { activate(vids[j]); playSafe(vids[j]); }
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { activate(en.target); playSafe(en.target); }
      else if (!en.target.paused) { en.target.pause(); }
    });
  }, { rootMargin: '200px 0px' });
  for (var k = 0; k < vids.length; k++) io.observe(vids[k]);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-origin-chapters"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__tvoVideo) return;
  window.__tvoVideo = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function activate(v) {
    if (!v.dataset.pending) return;
    delete v.dataset.pending;
    var sources = v.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].dataset.src;
      sources[i].removeAttribute('data-src');
    }
    v.muted = true;
    v.load();
  }
  function playSafe(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  var vids = document.querySelectorAll('video[data-tvo-video]');
  if (!vids.length) return;
  for (var i = 0; i < vids.length; i++) vids[i].dataset.pending = '1';
  if (reduce || !('IntersectionObserver' in window)) {
    if (!reduce) for (var j = 0; j < vids.length; j++) { activate(vids[j]); playSafe(vids[j]); }
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { activate(en.target); playSafe(en.target); }
      else if (!en.target.paused) { en.target.pause(); }
    });
  }, { rootMargin: '200px 0px' });
  for (var k = 0; k < vids.length; k++) io.observe(vids[k]);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-origin-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__tvoVideo) return;
  window.__tvoVideo = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function activate(v) {
    if (!v.dataset.pending) return;
    delete v.dataset.pending;
    var sources = v.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].dataset.src;
      sources[i].removeAttribute('data-src');
    }
    v.muted = true;
    v.load();
  }
  function playSafe(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  var vids = document.querySelectorAll('video[data-tvo-video]');
  if (!vids.length) return;
  for (var i = 0; i < vids.length; i++) vids[i].dataset.pending = '1';
  if (reduce || !('IntersectionObserver' in window)) {
    if (!reduce) for (var j = 0; j < vids.length; j++) { activate(vids[j]); playSafe(vids[j]); }
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { activate(en.target); playSafe(en.target); }
      else if (!en.target.paused) { en.target.pause(); }
    });
  }, { rootMargin: '200px 0px' });
  for (var k = 0; k < vids.length; k++) io.observe(vids[k]);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv2-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tv2-add]').forEach(function (btn) {
    if (btn.dataset.tv2Wired) return;
    btn.dataset.tv2Wired = '1';
    btn.addEventListener('click', function () {
      var form = document.querySelector(
        '.main-product-form, product-form form, form[action*="/cart/add"]'
      );
      if (!form) return;
      var submit = form.querySelector('[name="add"]');
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submit || undefined);
      } else if (submit) {
        submit.click();
      }
      var label = btn.querySelector('.tv2-cta__label');
      if (label && !btn.dataset.tv2Busy) {
        btn.dataset.tv2Busy = '1';
        var prev = label.textContent;
        label.textContent = 'added ✓';
        btn.classList.add('is-added');
        setTimeout(function () {
          label.textContent = prev;
          btn.classList.remove('is-added');
          delete btn.dataset.tv2Busy;
        }, 1600);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv2-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tvr-arrow]');
    if (!btn) return;
    var root = btn.closest('.tvr-car');
    var track = root && root.querySelector('.tvr-car__track');
    if (!track) return;
    var card = track.querySelector('.tvr-car__card');
    var step = card ? card.offsetWidth + 16 : 280;
    track.scrollBy({ left: btn.getAttribute('data-tvr-arrow') === 'next' ? step : -step, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
